
import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPhoneSquare,
  FaTwitter,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Doctor1 from "../../Assets/Images/Psyciatrist1.webp";
import Doctor2 from "../../Assets/Images/Councellors6.jpg";
import Doctor3 from "../../Assets/Images/Councellors7.avif";
import Doctor4 from "../../Assets/Images/Councellors8.webp";
import { MdMail } from "react-icons/md";
import { LiaStethoscopeSolid } from "react-icons/lia";

const Experts = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Wabz Braize",
      role: "Counselling Psychologist",
      image: Doctor1,
    },
    {
      id: 2,
      name: "Ethan Hunt",
      role: "Therapist",
      image: Doctor2,
    },
    {
      id: 3,
      name: "Raven Kent",
      role: "Peer Listener",
      image: Doctor3,
    },
    {
      id: 4,
      name: "John Doe",
      role: "Career Coach",
      image: Doctor4,
    },
  ];

  const tags = [
    "Relationship Coach",
    "Counselling Psychologist",
    "Clinical Psychologist",
    "Life Coach",
    "Therapist",
    "Positivity Coach",
    "Career Coach",
    "Sexual Wellness Coach",
    "Mindset Transformation Coach",
  ];

  return (
    <div className="pb-28 pt-10 px-4 sm:px-[5%] bg-gradient-to-t from-[#f7f7fe] to-[#f5f5ff]">
      <div className="flex flex-col justify-center items-center">
        <h3 className="bg-primary/10 text-lg text-accent px-5 font-semibold rounded-3xl">
          Our Team
        </h3>
        <h2 className="mt-5 text-2xl sm:text-3xl text-center text-primaraytext font-bold">
          A Qualified{" "}
          <span className="text-accent font-serif">Panel Of Experts</span>{" "}
          Dedicated To <br className="hidden md:block" /> Helping You Feel Like A Whole
        </h2>

        {/* Tags */}
        <div
          className="flex flex-wrap justify-center gap-3 mb-8 mt-10 mx-4 sm:mx-8 md:mx-16 lg:mx-32"
          data-aos="zoom-in"
        >
          {tags.map((tag, index) => (
            <button
              key={index}
              className="px-4 py-2 rounded-lg font-medium bg-primary/10 hover:bg-accent/80 text-primaraytext transition duration-300"
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Expert Cards */}
        <div className="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {teamMembers.map(({ id, name, role, image }) => (
            <div
              key={id}
              className="min-h-[300px] w-full rounded-lg mb-10 light-shadow"
            >
              <img
                src={image}
                alt={name}
                className="object-cover w-full h-64 rounded-lg hover:scale-95 transition duration-300"
                data-aos="flip-right"
                data-aos-duration="3000"
              />
              <div className="relative z-10 w-11/12 sm:w-4/5 p-3 mx-auto -mt-10 text-center bg-white rounded-lg shadow-md dark:bg-dark-light">
                <h1 className="text-lg font-semibold">{name}</h1>
                <p className="text-sm text-gray-600">{role}</p>
                <div className="mt-3 flex justify-between items-center">
                  <div className="flex gap-x-3">
                    <a href="#" className="hover:text-primary transition">
                      <FaPhoneSquare className="h-4 w-4" />
                    </a>
                    <a href="#" className="hover:text-primary transition">
                      <MdMail className="h-4 w-4" />
                    </a>
                  </div>
                  <div className="bg-primary hover:scale-90 flex items-center gap-2 transition duration-300 shadow text-white px-2 py-1 rounded-sm">
                    <LiaStethoscopeSolid className="h-4 w-4" />
                    <button className="text-sm font-normal">Book Now</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <a
          href="https://web.doxzon.com"
          className="text-accent font-medium text-lg sm:text-xl hover:underline mt-16"
        >
          View All Experts
        </a>
      </div>
    </div>
  );
};

export default Experts;
